export class SignatureTabViewModel {
  public cannotTakeSignature = false;
  public signature = "";
}
